import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { IOfferRequestAccess } from '../../../interfaces';
import { formatDateString } from '../../../shared/utility';
import { ETranslation } from '../../../translations/translation-keys';
import Table from '../../UI/Table/Table';
import TableTh from '../../UI/Table/TableTh/TableTh';
import { useTableSort } from '../../UI/Table/useTableSort';
import classes from './OfferRequestAccessTable.module.scss';

interface IProps {
  offerRequestAccess: Array<IOfferRequestAccess>
  statusProp?: string;
  onClick: (event: React.MouseEvent<HTMLTableRowElement>, id: string) => void;
  sortable?: boolean;
  containerClassName?: string;
  containerStyle?: CSSProperties;
  isPrimary?: boolean;
}

const OfferRequestAccessTable: React.FC<IProps> = ({ offerRequestAccess, statusProp, onClick, sortable, containerClassName, containerStyle, isPrimary }) => {
  const { t } = useTranslation();
  const { sort, onSort, items: sortedOfferRequestAccess } = useTableSort({ data: offerRequestAccess });

  return (
    <div className={containerClassName} style={containerStyle}>
      <Table hover sortContext={{ sort, onSort }}>
        <thead>
          <tr className={classes.TableHeader}>
            {statusProp}
            {sortable ? (
              <>
                <TableTh sort="created" type="date">{t(ETranslation.OFFER_REQUEST_ACCESS_CREATED)}</TableTh>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_OFFER_REQUEST)}</th>
                <TableTh sort="offerRequestCreated" type="date">{t(ETranslation.OFFER_REQUEST_ACCESS_OFFER_REQUEST_CREATED)}</TableTh>
                <TableTh sort="serviceName">{t(ETranslation.SERVICE_NAME)}</TableTh>
                <TableTh sort="user.name">{t(ETranslation.OFFER_REQUEST_ACCESS_USERNAME)}</TableTh>
                <TableTh sort="user.organization.name">{t(ETranslation.SERVICEPROVIDER_COMPANY)}</TableTh>
              </>
            ) : (
              <>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_CREATED)}</th>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_OFFER_REQUEST)}</th>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_OFFER_REQUEST_CREATED)}</th>
                <th>{t(ETranslation.SERVICE_NAME)}</th>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_USERNAME)}</th>
                <th>{t(ETranslation.SERVICEPROVIDER_COMPANY)}</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedOfferRequestAccess.map(access => {
            return (
              <tr key={access.id} onClick={(e) => onClick(e, access.offerRequestId)}>
                <td>{access.created && formatDateString(access.created)}</td>
                <td>{access.offerRequestUserName}</td>
                <td>{access.offerRequestCreated && formatDateString(access.offerRequestCreated)}</td>
                <td>{access.serviceName}</td>
                <td>{access.user?.name}</td>
                <td>{access.user?.organization?.name}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default OfferRequestAccessTable;